/* ============================================================
   MUHRA AI SHOPPING ADVISOR — storefront widget
   Talks to the Supabase function set in data-endpoint.
   Add to cart uses Shopify's own /cart/add.js.
   ============================================================ */
(function () {
  'use strict';
  var root = document.getElementById('muhra-ai');
  if (!root || root._mai) return;
  root._mai = true;

  var ENDPOINT = root.getAttribute('data-endpoint');
  var PRODUCT = root.getAttribute('data-product') || '';
  var PRODUCT_TITLE = root.getAttribute('data-product-title') || '';
  var LOCALE = (root.getAttribute('data-lang') || document.documentElement.lang || 'en').toLowerCase();
  var AR = true; // Arabic-first: the chat always opens in Arabic; replies follow the customer's language
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORE_KEY = 'muhraAI.v1';

  var T_ALL = {
    launch: 'اسألي مهرة', title: 'مستشارة مهرة', sub: 'مساعدة تسوق ذكية',
    hello: 'أهلاً بحضرتك في مهرة 🤎 أقدر أساعدك تختاري المقاس، تلاقي القطعة المناسبة، أو تعرفي أي معلومة عن الشحن والاسترجاع.',
    helloProduct: 'أهلاً بحضرتك 🤎 عندك سؤال عن **{p}**؟ أقدر أساعدك في المقاس، الخامة، أو تنسيق القطعة.',
    ph: 'اكتبي سؤالك هنا…', send: 'إرسال', close: 'إغلاق',
    chips: ['ساعديني أختار مقاسي', 'الشحن والتوصيل', 'سياسة الاسترجاع', 'رشحيلي لبس للشغل'],
    chipsProduct: ['إيه المقاس المناسب ليا؟', 'الخامة إيه؟', 'أنسقها مع إيه؟', 'الشحن والتوصيل'],
    add: 'أضيفي للسلة', added: 'اتضافت ✓', soldout: 'نفدت', viewCart: 'عرض السلة', adding: 'جاري الإضافة…',
    err: 'حصلت مشكلة في الاتصال. جربي تاني بعد لحظات.', busy: 'المساعدة مشغولة دلوقتي، جربي تاني بعد دقيقة.',
    note: 'إجابات آلية — راجعي التفاصيل في صفحة المنتج', addErr: 'مقدرناش نضيفها، جربي من صفحة المنتج.',
    retry: 'إعادة المحاولة', chart: 'جدول المقاسات — اضغطي للتكبير'
  }, T_EN = {
    launch: 'Ask Muhra', title: 'Muhra Advisor', sub: 'Your personal shopping assistant',
    hello: 'Welcome to Muhra 🤎 I can help you find your size, discover the right piece, or answer questions about shipping and returns.',
    helloProduct: 'Welcome 🤎 Any questions about **{p}**? I can help with sizing, fabric, or styling it.',
    ph: 'Type your question…', send: 'Send', close: 'Close',
    chips: ['Help me find my size', 'Shipping & delivery', 'Returns policy', 'Suggest an office outfit'],
    chipsProduct: ['What size should I get?', 'What fabric is it?', 'What does it go with?', 'Shipping & delivery'],
    add: 'Add to cart', added: 'Added ✓', soldout: 'Sold out', viewCart: 'View cart', adding: 'Adding…',
    err: 'Connection problem. Please try again in a moment.', busy: 'The advisor is busy right now — please try again in a minute.',
    note: 'AI answers — please check details on the product page', addErr: "Couldn't add it — please try from the product page.",
    retry: 'Try again', chart: 'Size chart — tap to enlarge'
  };
  var T = T_ALL;
  // Status messages (errors, retry) follow the language of the customer's last message.
  function tt(key) {
    for (var i = state.msgs.length - 1; i >= 0; i--) {
      if (state.msgs[i].role !== 'user') continue;
      var t = state.msgs[i].text || '';
      return (/[؀-ۿ]/.test(t) || !/[A-Za-z]/.test(t)) ? T_ALL[key] : T_EN[key];
    }
    return T_ALL[key];
  }

  /* ---------- state ---------- */
  var state = { open: false, msgs: [] }; // msgs: {role:'user'|'assistant', text, cards?}
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
    if (saved && Array.isArray(saved.msgs)) state = saved;
  } catch (e) {}
  var PROFILE_KEY = 'muhraAI.profile';
  var profile = {};
  try { profile = JSON.parse(localStorage.getItem(PROFILE_KEY) || sessionStorage.getItem(PROFILE_KEY) || '{}') || {}; } catch (e) {}
  function saveProfile(p) {
    if (!p || typeof p !== 'object') return;
    profile = p;
    var raw = JSON.stringify(p);
    try { localStorage.setItem(PROFILE_KEY, raw); } catch (e) {}
    try { sessionStorage.setItem(PROFILE_KEY, raw); } catch (e) {}
  }
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ open: state.open, msgs: state.msgs.slice(-30) })); } catch (e) {} }

  /* ---------- markup ---------- */
  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/><path d="M8.5 11h.01M12 11h.01M15.5 11h.01"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  root.setAttribute('dir', AR ? 'rtl' : 'ltr');
  root.innerHTML =
    '<button type="button" class="mai-launch" aria-label="' + T.launch + '">' + ICON_CHAT + '<span>' + T.launch + '</span></button>' +
    '<section class="mai-panel" role="dialog" aria-label="' + T.title + '">' +
      '<header class="mai-head"><div class="mai-avatar">M</div><div class="mai-title"><b>' + T.title + '</b><span>' + T.sub + '</span></div>' +
      '<button type="button" class="mai-x" aria-label="' + T.close + '">' + ICON_X + '</button></header>' +
      '<div class="mai-body" aria-live="polite"></div>' +
      '<div class="mai-foot"><form class="mai-form"><textarea class="mai-input" rows="1" maxlength="600" placeholder="' + T.ph + '" aria-label="' + T.ph + '"></textarea>' +
      '<button type="submit" class="mai-send" aria-label="' + T.send + '">' + ICON_SEND + '</button></form>' +
      '<p class="mai-note">' + T.note + '</p></div>' +
    '</section>';

  var launch = root.querySelector('.mai-launch');
  var closeBtn = root.querySelector('.mai-x');
  var body = root.querySelector('.mai-body');
  var form = root.querySelector('.mai-form');
  var input = root.querySelector('.mai-input');
  var sendBtn = root.querySelector('.mai-send');
  var busy = false;

  /* ---------- rendering ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function fmt(text) {
    var h = esc(text);
    h = h.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    h = h.replace(/(^|[^*])\*(?!\s)([^*\n]+?)\*(?!\*)/g, '$1<em>$2</em>');
    h = h.replace(/(https?:\/\/(?:www\.)?muhrastore\.com[^\s<)]*)/g, '<a href="$1">$1</a>');
    h = h.replace(/([\w.+-]+@[\w-]+\.[\w.]+)/g, '<a href="mailto:$1">$1</a>');
    var lines = h.split(/\n/), out = '', inList = false;
    lines.forEach(function (l) {
      var m = l.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)/);
      if (m) { if (!inList) { out += '<ul>'; inList = true; } out += '<li>' + m[1] + '</li>'; }
      else { if (inList) { out += '</ul>'; inList = false; } if (l.trim()) out += (out && !/<\/ul>$/.test(out) ? '<br>' : '') + l; }
    });
    if (inList) out += '</ul>';
    return out;
  }

  function money(n) { return (Number(n) || 0).toLocaleString('en-US') + (AR ? ' ج.م' : ' EGP'); }

  function bubble(role, text) {
    var row = document.createElement('div');
    row.className = 'mai-msg ' + (role === 'user' ? 'mai-user' : 'mai-bot');
    var b = document.createElement('div');
    b.className = 'mai-bubble';
    b.setAttribute('dir', 'auto');
    b.innerHTML = fmt(text);
    row.appendChild(b);
    body.appendChild(row);
  }

  function cardsEl(cards) {
    var wrap = document.createElement('div');
    wrap.className = 'mai-cards';
    cards.forEach(function (c) {
      var card = document.createElement('div');
      card.className = 'mai-card';
      var url = c.url || ('/products/' + c.handle);
      var opts = (c.variants || []).map(function (v) {
        return '<option value="' + esc(v.id) + '"' + (v.available ? '' : ' disabled') + (String(v.id) === String(c.selected) ? ' selected' : '') + '>' +
          esc(v.label) + (v.available ? '' : ' — ' + T.soldout) + '</option>';
      }).join('');
      var single = (c.variants || []).length <= 1;
      card.innerHTML =
        '<a class="mai-card-img" href="' + esc(url) + '">' + (c.img ? '<img loading="lazy" src="' + esc(c.img) + '" alt="' + esc(c.title) + '">' : '') + '</a>' +
        '<div class="mai-card-b"><a class="mai-card-t" href="' + esc(url) + '">' + esc(c.title) + '</a>' +
        '<div class="mai-card-p">' + money(c.price_egp) + (c.was_egp ? '<s>' + money(c.was_egp) + '</s>' : '') + '</div>' +
        (single ? '' : '<select aria-label="variant">' + opts + '</select>') +
        '<button type="button" class="mai-add"' + (c.available ? '' : ' disabled') + '>' + (c.available ? T.add : T.soldout) + '</button></div>';
      var sel = card.querySelector('select');
      var img = card.querySelector('.mai-card-img img');
      if (sel) sel.addEventListener('change', function () {
        var v = (c.variants || []).filter(function (x) { return String(x.id) === sel.value; })[0];
        if (v && v.img && img) img.src = v.img;
        var btn = card.querySelector('.mai-add'); btn.classList.remove('mai-done'); btn.textContent = T.add; btn.disabled = false;
      });
      card.querySelector('.mai-add').addEventListener('click', function () {
        var id = sel ? sel.value : (c.selected || (c.variants && c.variants[0] && c.variants[0].id));
        addToCart(id, this, card);
      });
      wrap.appendChild(card);
    });
    body.appendChild(wrap);
  }

  function imagesEl(imgs) {
    imgs.forEach(function (im) {
      if (!im || !/^https:\/\//.test(im.url)) return;
      var row = document.createElement('div');
      row.className = 'mai-msg mai-bot';
      row.innerHTML = '<a class="mai-chart" href="' + esc(im.url) + '" target="_blank" rel="noopener">' +
        '<img loading="lazy" src="' + esc(im.url) + '" alt="' + esc(im.caption || T.chart) + '">' +
        '<span>' + esc((im.caption ? im.caption + ' · ' : '') + T.chart) + '</span></a>';
      var img = row.querySelector('img');
      img.addEventListener('load', scroll);
      body.appendChild(row);
    });
  }

  function chips(list) {
    var w = document.createElement('div');
    w.className = 'mai-chips';
    list.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mai-chip'; b.textContent = t;
      b.addEventListener('click', function () { w.remove(); send(t); });
      w.appendChild(b);
    });
    body.appendChild(w);
  }

  function renderAll() {
    body.innerHTML = '';
    var hello = PRODUCT && PRODUCT_TITLE ? T.helloProduct.replace('{p}', PRODUCT_TITLE) : T.hello;
    bubble('assistant', hello);
    state.msgs.forEach(function (m) {
      bubble(m.role, m.text);
      if (m.images && m.images.length) imagesEl(m.images);
      if (m.cards && m.cards.length) cardsEl(m.cards);
    });
    if (!state.msgs.length) chips(PRODUCT ? T.chipsProduct : T.chips);
    scroll();
  }

  function scroll() { body.scrollTop = body.scrollHeight; }

  function typing(on) {
    var t = body.querySelector('.mai-typing-row');
    if (on && !t) {
      t = document.createElement('div');
      t.className = 'mai-msg mai-bot mai-typing-row';
      t.innerHTML = '<div class="mai-bubble mai-typing"><i></i><i></i><i></i></div>';
      body.appendChild(t); scroll();
    } else if (!on && t) t.remove();
  }

  /* ---------- open / close ---------- */
  function setOpen(o) {
    state.open = o; save();
    root.classList.toggle('mai-open', o);
    if (o) { renderAll(); setTimeout(function () { input.focus(); }, 50); }
  }
  launch.addEventListener('click', function () {
    if (suppressClick) { suppressClick = false; return; }
    setOpen(true);
  });

  /* ---------- launcher position: above bottom menus + draggable ---------- */
  var POS_KEY = 'muhraAI.pos';
  var pos = null; // { side: 'left'|'right', b: px from bottom } — set when the customer drags the button
  try { pos = JSON.parse(localStorage.getItem(POS_KEY) || 'null'); } catch (e) {}
  var drag = null, suppressClick = false;
  launch.style.touchAction = 'none';
  launch.style.userSelect = 'none';
  launch.style.webkitUserSelect = 'none';
  launch.setAttribute('title', AR ? 'اسحبي الزر لتحريكه' : 'Drag to move');

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  // Height taken by fixed bars at the bottom of the screen (mobile menu, sticky add-to-cart, cookie bars...)
  function bottomObstacle() {
    var h = window.innerHeight, max = 0;
    [0.1, 0.3, 0.5, 0.7, 0.9].forEach(function (fx) {
      var el = document.elementFromPoint(window.innerWidth * fx, h - 3);
      while (el && el !== document.body && el !== document.documentElement) {
        if (root.contains(el)) break;
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'sticky') {
          var r = el.getBoundingClientRect();
          if (r.bottom >= h - 4 && r.height < h * 0.45) max = Math.max(max, h - r.top);
          break;
        }
        el = el.parentElement;
      }
    });
    return max;
  }

  function applyPos() {
    if (drag && drag.moved) return;
    var side = pos && pos.side === 'left' ? 'left' : (pos ? 'right' : (root.getAttribute('data-side') === 'left' ? 'left' : 'right'));
    var b = pos ? pos.b : Math.max(20, bottomObstacle() + 12);
    b = clamp(b, 8, window.innerHeight - (launch.offsetHeight || 48) - 8);
    launch.style.top = 'auto';
    launch.style.left = side === 'left' ? '16px' : 'auto';
    launch.style.right = side === 'right' ? '16px' : 'auto';
    launch.style.bottom = b + 'px';
  }

  launch.addEventListener('pointerdown', function (e) {
    if (e.button && e.button !== 0) return;
    drag = { x0: e.clientX, y0: e.clientY, r: launch.getBoundingClientRect(), moved: false, id: e.pointerId };
  });
  window.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
    if (!drag.moved) {
      if (Math.abs(dx) + Math.abs(dy) < 8) return;
      drag.moved = true;
      try { launch.setPointerCapture(drag.id); } catch (err) {}
      launch.style.transition = 'none';
      launch.style.opacity = '0.9';
      launch.style.cursor = 'grabbing';
    }
    e.preventDefault();
    var w = drag.r.width, hgt = drag.r.height;
    launch.style.left = clamp(drag.r.left + dx, 4, window.innerWidth - w - 4) + 'px';
    launch.style.top = clamp(drag.r.top + dy, 4, window.innerHeight - hgt - 4) + 'px';
    launch.style.right = 'auto';
    launch.style.bottom = 'auto';
  }, { passive: false });
  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var d = drag; drag = null;
    if (!d.moved) return;
    suppressClick = true;
    setTimeout(function () { suppressClick = false; }, 400);
    var r = launch.getBoundingClientRect();
    pos = { side: (r.left + r.width / 2) < window.innerWidth / 2 ? 'left' : 'right', b: Math.round(window.innerHeight - r.bottom) };
    try { localStorage.setItem(POS_KEY, JSON.stringify(pos)); } catch (err) {}
    launch.style.transition = '';
    launch.style.opacity = '';
    launch.style.cursor = '';
    applyPos();
  }
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);

  var posTimer = null;
  function schedulePos() { clearTimeout(posTimer); posTimer = setTimeout(applyPos, 150); }
  window.addEventListener('resize', schedulePos);
  window.addEventListener('scroll', function () { if (!pos) schedulePos(); }, { passive: true });
  applyPos();
  setTimeout(applyPos, 800);
  setTimeout(applyPos, 2500);
  closeBtn.addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) setOpen(false); });

  /* ---------- send ---------- */
  function retryChip() {
    var w = document.createElement('div');
    w.className = 'mai-chips mai-retry';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mai-chip'; b.textContent = tt('retry');
    b.addEventListener('click', function () { w.remove(); send(null, true); });
    w.appendChild(b);
    body.appendChild(w);
  }

  function send(text, isRetry) {
    if (busy) return;
    if (isRetry) {
      var last = state.msgs[state.msgs.length - 1];
      if (!last || last.role !== 'user') return;
    } else {
      text = String(text || '').trim();
      if (!text) return;
    }
    busy = true; sendBtn.disabled = true;
    var chipsEl = body.querySelectorAll('.mai-chips'); for (var i = 0; i < chipsEl.length; i++) chipsEl[i].remove();
    if (!isRetry) {
      state.msgs.push({ role: 'user', text: text.slice(0, 600) });
      save();
      bubble('user', text);
      input.value = ''; autosize();
    }
    scroll();
    typing(true);

    var history = state.msgs.slice(-20).map(function (m) {
      return { role: m.role, text: m.role === 'assistant' ? String(m.text).slice(0, 500) : m.text };
    });
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 90000);

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history, page: { handle: PRODUCT, url: location.pathname }, lang: LOCALE, profile: profile }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, status: r.status, d: d }; });
    }).then(function (res) {
      typing(false);
      if (!res.ok || !res.d.reply) {
        bubble('assistant', res.status === 429 ? tt('busy') : tt('err'));
        retryChip();
      } else {
        if (res.d.profile) saveProfile(res.d.profile);
        var m = { role: 'assistant', text: res.d.reply, cards: res.d.cards || [], images: res.d.images || [] };
        state.msgs.push(m); save();
        bubble('assistant', m.text);
        if (m.images.length) imagesEl(m.images);
        if (m.cards.length) cardsEl(m.cards);
      }
      scroll();
    }).catch(function () {
      typing(false); bubble('assistant', tt('err')); retryChip(); scroll();
    }).then(function () {
      clearTimeout(timer); busy = false; sendBtn.disabled = false;
    });
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(input.value); }
  });
  function autosize() { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 110) + 'px'; }
  input.addEventListener('input', autosize);

  /* ---------- cart ---------- */
  function addToCart(variantId, btn, card) {
    if (!variantId) return;
    btn.disabled = true; btn.textContent = T.adding;
    fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _source: 'AI advisor' } }] })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.textContent = T.added; btn.classList.add('mai-done'); btn.disabled = false;
        if (!card.querySelector('.mai-cartlink')) {
          var a = document.createElement('a'); a.className = 'mai-cartlink'; a.href = ROOT_URL + 'cart'; a.textContent = T.viewCart;
          card.querySelector('.mai-card-b').appendChild(a);
        }
        refreshCartCount();
      })
      .catch(function () { btn.textContent = T.add; btn.disabled = false; bubble('assistant', tt('addErr')); scroll(); });
  }

  function refreshCartCount() {
    fetch(ROOT_URL + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = cart.item_count;
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span:first-child, .cartCount, [data-cart-item-count]').forEach(function (el) { el.textContent = n; });
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) {}
    }).catch(function () {});
  }

  /* ---------- boot ---------- */
  // The panel never re-opens by itself on a new page (product, cart, etc.).
  // The conversation is kept and shown again when the customer taps the button.
  if (state.open) { state.open = false; save(); }

  // Any link inside the chat (product card, cart, size chart) closes the panel before leaving.
  root.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a && a.target !== '_blank') { state.open = false; save(); }
  });
})();
